<div (click)="onClick($event)"
    matTooltip="Home">

    <button mat-button [color]="active ? buttonActive : ''">
        <mat-icon [ngClass]="showLabel ? '' : 'noLabel'" aria-label="Home view">
            {{ icon }}
        </mat-icon>

        <div class="sidebar-label" *ngIf="showLabel">Home</div>
    </button>
</div>